<template>
	<div class="table">
		<tr>
			<td>Monthly rent</td>
			<td class="has-text-right">{{ $store.state.evaluation.calculator.hardMonthlyRent | currency(0) }}</td>
		</tr>
		<tr>
			<td>Note payment</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardRefinanceNotePaymentMonthly *	-1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Property tax</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardPropertyTaxMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Property insurance</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardPropertyInsuranceMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Mortgage insurance</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardMortgageInsuranceMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>HOA</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardHoaMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Misc monthly</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.hardMiscellaneousMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td class="has-text-weight-semibold">TOTAL</td>
			<td class="has-text-right has-text-weight-semibold">{{ $store.state.evaluation.calculator.hardTotalCashflowMonthly | currency(0) }}</td>
		</tr>
	</div>
</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  }
};
</script>
